import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import ShabaCodeModal from "./ShabaCodeModal";

const VendorCommercialInformation = () => {
    return (
        <div className="vendor-commercial-information-wrapper">
            <div className="info-title">
                <h2 className="title">اطلاعات تجاری</h2>
            </div>
            <div className="inputs-box">
                <div className="row">
                    <div className="col-xl-5 col-md-6">
                    <input type="text" className="input-personal-info" placeholder="نام فروشگاه شما در سایمان دیجیتال"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                    <div className="select-input position-relative xmt-6 xmt-md-0">
                        <select className="form-select input-personal-info">
                            <option value="default">دسته بندی محصول</option>
                            <option>اصفهان</option>
                            <option>تهران</option>
                            <option>تهران</option>
                            <option>تهران</option>
                            <option>تهران</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    </div>
                    <div className="col-xl-10 col-md-12">
                    <div
                        className="shaba-code-input position-relative full-input d-flex align-items-center justify-content-between xmt-6"
                        id="shaba-code-input">
                        <span className="text-input">شماره شبا (به نام شخص یا شرکت ثبت نام کننده)</span>
                        <span className="shaba-code d-none d-lg-block">IR1234567891234567891234</span>
                    </div>
                    </div>
                    <div className="col-xl-5 col-md-6">
                    <div className="select-input position-relative xmt-6">
                        <select className="form-select input-personal-info">
                            <option value="default">تعداد حدودی تنوع کالای آماده فروش</option>
                            <option>اصفهان</option>
                            <option>تهران</option>
                            <option>تهران</option>
                            <option>تهران</option>
                            <option>تهران</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    </div>
                </div>
            </div>
            <ShabaCodeModal/>
        </div>
    );
};

export default VendorCommercialInformation;
